import ChildInfo from "./ChildInfo";

export default ChildInfo;
